import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointSuggestListGroupTemplate]',
  standalone: true
})
export class QPointSuggestListGroupTemplateDirective {
}
